import { createContext, useContext } from "react";

/**
 * Marks the Dialog header-actions slot. A `Button` rendered inside reads this
 * (via `useIsInDialogHeader`) and switches to the borderless, brand-blue
 * icon-action style that matches the dialog's peek/close controls — the look
 * formerly provided by the separate `DialogActionButton`. Mirrors
 * `ControlBarContext`: the context, not a prop, tells the Button what it is.
 */
const DialogHeaderContext = createContext<boolean>(false);

export const DialogHeaderProvider = DialogHeaderContext.Provider;
export const useIsInDialogHeader = () => useContext(DialogHeaderContext);
